const toNumber = (value) => {
    if (value === null || value === undefined || value === '')
    {
        return null;
    }

    const number = Number(value);

    return Number.isFinite(number) ? number : null;
};

const formatInteger = (value) => {
    const number = toNumber(value);

    return number || number === 0 ?
        new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(number) :
        null;
};

const formatPriceValue = (value) => {
    const number = toNumber(value);

    if (!(number || number === 0))
    {
        return null;
    }

    if (number === 0)
    {
        return '$0';
    }

    return `$${ number.toFixed(Math.abs(number) < 0.01 ? 4 : 2) }`;
};

const TranslationAiFormatHelper = {
    toNumber,
    formatInteger,
    formatPriceValue,
};

export default TranslationAiFormatHelper;
